require('any-observable/register')('rxjs', {Observable: require('rxjs').Observable});
import Vue from 'vue'

import Cookies from 'js-cookie'
import VueClipboard from 'vue-clipboard2'
// import QRCode from 'qrcodejs2'



import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './assets/styles/element-variables.scss'

import '@/assets/styles/index.scss' // global css
import '@/assets/styles/style.scss'
import '@/styles/form-theme-global.scss' // 问卷表单主题全局样式
import App from './App'
import store from './store'
import router from './router'
import permission from './directive/permission'

import './assets/icons' // icon
import './permission' // permission control
import { getDicts } from "@/api/sys/dict";
import { getConfigKey } from "@/api/sys/config";
import { parseTime, resetForm, addDateRange, selectDictLabel, download, handleTree } from "@/utils/commonUtil";
import Pagination from "@/components/Pagination";
import Dispicker from '@/components/Dispicker'
import BaiduMap from 'vue-baidu-map' //引入百度地图
import axios from 'axios';
import ylTable from '@/components/yl-pc/table/table'
import ImageSelect from "@/components/form/ImageSelect";
import SortQuestion from "@/components/form/SortQuestion";
import ScaleQuestion from "@/components/form/ScaleQuestion";
import EditableRadioOption from "@/components/form/EditableRadioOption";
import EditableCheckBoxOption from "@/components/form/EditableCheckBoxOption";
import QuesPagination from "@/components/form/QuesPagination";
import SignPad from "@/components/form/SignPad";
import CheckItem from "@/components/form/CheckItem";
import countDown from '@/components/countDown/index'
import i18n from './i18n/i18n'; //i18n国际化

// 全局方法挂载
Vue.prototype.getDicts = getDicts
Vue.prototype.getConfigKey = getConfigKey
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree

Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
}

Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
}

Vue.prototype.$axios = axios

// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.component('Dispicker', Dispicker)
Vue.component('ImageSelect', ImageSelect)
Vue.component('SortQuestion', SortQuestion)
Vue.component('sort-select', SortQuestion)
Vue.component('ScaleQuestion', ScaleQuestion)
Vue.component('scale-question', ScaleQuestion)
Vue.component('EditableRadioOption', EditableRadioOption)
Vue.component('EditableCheckBoxOption', EditableCheckBoxOption)

Vue.component('QuesPagination', QuesPagination)
Vue.component('SignPad', SignPad)
Vue.component('CheckItem', CheckItem)
Vue.component('check-item', CheckItem)
Vue.component('countDown', countDown)


Vue.use(Element, {
	i18n: (key, value) => i18n.t(key, value), //i18n国际化
});
Vue.use(permission)
Vue.use(VueClipboard)
// Vue.use(QRCode)
Vue.component('yl-table', ylTable)


//引入ui2
import ViewUI from "view-design"
import 'view-design/dist/styles/iview.css'
Vue.use(ViewUI);

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);


Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})
//使用百度地图组件
Vue.use(BaiduMap, {
  ak:"oftl4jQIPQZbKsaBWqoMxLSfh9bDBVYm"
})
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  i18n, //i18n国际化
  store,
  render: h => h(App)
})

//全局修改dialog点击灰色区域不自动关闭
Element.Dialog.props.closeOnClickModal.default = false;


// 全局组件自动注册




